"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDurationIconBackground", {
    enumerable: true,
    get: function() {
        return useDurationIconBackground;
    }
});
const _react = require("react");
const useDurationIconBackground = (param)=>{
    let { color } = param;
    return (0, _react.useMemo)(()=>{
        const svg = "<svg width='16' height='16' viewBox='0 0 16 16' fill='".concat(color, "' xmlns='http://www.w3.org/2000/svg'><path d='M8.0151 14.6801C4.33402 14.6801 1.3501 11.6962 1.3501 8.0151C1.3501 4.33402 4.33402 1.3501 8.0151 1.3501C11.6962 1.3501 14.6801 4.33402 14.6801 8.0151C14.6801 11.6962 11.6962 14.6801 8.0151 14.6801ZM8.0151 13.3471C9.42923 13.3471 10.7854 12.7853 11.7854 11.7854C12.7853 10.7854 13.3471 9.42923 13.3471 8.0151C13.3471 6.60096 12.7853 5.24475 11.7854 4.2448C10.7854 3.24486 9.42923 2.6831 8.0151 2.6831C6.60096 2.6831 5.24475 3.24486 4.2448 4.2448C3.24486 5.24475 2.6831 6.60096 2.6831 8.0151C2.6831 9.42923 3.24486 10.7854 4.2448 11.7854C5.24475 12.7853 6.60096 13.3471 8.0151 13.3471ZM8.6816 8.0151H11.3476V9.3481H7.3486V4.6826H8.6816V8.0151Z' /></svg>");
        return 'url("data:image/svg+xml;base64,'.concat(btoa(svg), '")');
    }, [
        color
    ]);
};

//# sourceMappingURL=useDurationIconBackground.js.map